"use client";
import {
	faBalanceScale,
	faCircleInfo,
	faFileContract,
	faGavel,
	faLock,
	faSitemap,
	faUserShield,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { motion } from "framer-motion";
import { useState } from "react";

const LegalPage = () => {
	const [activeSection, setActiveSection] = useState<string | null>(null);

	const legalSections = [
		{
			id: "identificacion",
			title: "Identificación y Titularidad",
			icon: faUserShield,
			content: (
				<>
					<p className="mb-4">
						En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de
						la Información y Comercio Electrónico, el Titular expone sus datos identificativos:
					</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>
							<strong>Titular:</strong> Sergio de Isidro Hontana.
						</li>
						<li>
							<strong>NIF:</strong> 04604219X
						</li>
						<li>
							<strong>Domicilio:</strong> Plaza campo de Criptana 25, 3A, Madrid - España.
						</li>
						<li>
							<strong>Correo electrónico:</strong>{" "}
							<a href="mailto:legal@losamosdelcalabozo.com" className="text-red-400 hover:text-red-300">
								legal@losamosdelcalabozo.com
							</a>
						</li>
						<li>
							<strong>Sitio Web:</strong>{" "}
							<a href="/" className="text-red-400 hover:text-red-300">
								https://www.losamosdelcalabozo.com
							</a>
						</li>
					</ul>
				</>
			),
		},
		{
			id: "finalidad",
			title: "Finalidad",
			icon: faSitemap,
			content: <p>La finalidad del Sitio Web es: servicios de director de juego.</p>,
		},
		{
			id: "condiciones",
			title: "Condiciones de Uso",
			icon: faFileContract,
			content: (
				<>
					<p className="mb-4">
						La utilización del Sitio Web le otorga la condición de Usuario, e implica la aceptación completa
						de todas las cláusulas y condiciones de uso incluidas en las páginas:
					</p>
					<ul className="list-disc pl-6 mb-4 space-y-2">
						<li>
							<a href="/aviso-legal/" className="text-red-400 hover:text-red-300">
								Aviso Legal
							</a>
						</li>
						<li>
							<a href="/politica-de-privacidad/" className="text-red-400 hover:text-red-300">
								Política de Privacidad
							</a>
						</li>
						<li>
							<a href="/politica-de-cookies/" className="text-red-400 hover:text-red-300">
								Política de Cookies
							</a>
						</li>
					</ul>
					<p className="mb-4">
						Si no estuviera conforme con todas y cada una de estas cláusulas y condiciones absténgase de
						utilizar el Sitio Web.
					</p>
					<p className="mb-4">
						El acceso al Sitio Web no supone, en modo alguno, el inicio de una relación comercial con el
						Titular.
					</p>
					<p className="mb-4">
						A través del Sitio Web, el Titular le facilita el acceso y la utilización de diversos contenidos
						que el Titular y/o sus colaboradores han publicado por medio de Internet.
					</p>
					<p>
						A tal efecto, está obligado y comprometido a NO utilizar cualquiera de los contenidos del Sitio
						Web con fines o efectos ilícitos, prohibidos en este Aviso Legal o por la legislación vigente,
						lesivos de los derechos e intereses de terceros, o que de cualquier forma puedan dañar,
						inutilizar, sobrecargar, deteriorar o impedir la normal utilización de los contenidos, los equipos
						informáticos o los documentos, archivos y toda clase de contenidos almacenados en cualquier equipo
						informático propios o contratados por el Titular, de otros usuarios o de cualquier usuario de
						Internet.
					</p>
				</>
			),
		},
		{
			id: "seguridad",
			title: "Medidas de Seguridad",
			icon: faLock,
			content: (
				<>
					<p className="mb-4">
						Los datos personales que facilite al Titular pueden ser almacenados en bases de datos
						automatizadas o no, cuya titularidad corresponde en exclusiva al Titular, que asume todas las
						medidas de índole técnica, organizativa y de seguridad que garantizan la confidencialidad,
						integridad y calidad de la información contenida en las mismas de acuerdo con lo establecido en la
						normativa vigente en protección de datos.
					</p>
					<p>
						No obstante, debe ser consciente de que las medidas de seguridad de los sistemas informáticos en
						Internet no son enteramente fiables y que, por tanto el Titular no puede garantizar la
						inexistencia de virus u otros elementos que puedan producir alteraciones en los sistemas
						informáticos (software y hardware) del Usuario o en sus documentos electrónicos y ficheros
						contenidos en los mismos aunque el Titular pone todos los medios necesarios y toma las medidas de
						seguridad oportunas para evitar la presencia de estos elementos dañinos.
					</p>
				</>
			),
		},
		{
			id: "datos",
			title: "Tratamiento de Datos Personales",
			icon: faUserShield,
			content: (
				<p>
					Puede consultar toda la información relativa al tratamiento de datos personales que recoge el
					Titular en la página de{" "}
					<a href="/politica-de-privacidad/" className="text-red-400 hover:text-red-300">
						Política de Privacidad
					</a>
					.
				</p>
			),
		},
		{
			id: "contenidos",
			title: "Contenidos",
			icon: faCircleInfo,
			content: (
				<>
					<p className="mb-4">
						El Titular ha obtenido la información, el contenido multimedia y los materiales incluidos en el
						Sitio Web de fuentes que considera fiables, pero, si bien ha tomado todas las medidas razonables
						para asegurar que la información contenida es correcta, el Titular no garantiza que sea exacta,
						completa o actualizada. El Titular declina expresamente cualquier responsabilidad por error u
						omisión en la información contenida en las páginas del Sitio Web.
					</p>
					<p className="mb-4">
						Queda prohibido transmitir o enviar a través del Sitio Web cualquier contenido ilegal o ilícito,
						virus informáticos, o mensajes que, en general, afecten o violen derechos del Titular o de
						terceros.
					</p>
					<p className="mb-4">
						Los contenidos del Sitio Web tienen únicamente una finalidad informativa y bajo ninguna
						circunstancia deben usarse ni considerarse como oferta de venta, solicitud de una oferta de compra
						ni recomendación para realizar cualquier otra operación, salvo que así se indique expresamente.
					</p>
					<p className="mb-4">
						El Titular se reserva el derecho a modificar, suspender, cancelar o restringir el contenido del
						Sitio Web, los vínculos o la información obtenida a través del Sitio Web, sin necesidad de previo
						aviso.
					</p>
					<p>
						El Titular no es responsable de los daños y perjuicios que pudieran derivarse de la utilización de
						la información del Sitio Web o de la contenida en las redes sociales del Titular.
					</p>
				</>
			),
		},
		{
			id: "cookies",
			title: "Política de cookies",
			icon: faCircleInfo,
			content: (
				<p>
					Puede consultar toda la información relativa a la política de recogida y tratamiento de las cookies
					en la página de{" "}
					<a href="/politica-de-cookies/" className="text-red-400 hover:text-red-300">
						Política de Cookies
					</a>
					.
				</p>
			),
		},
		{
			id: "enlaces",
			title: "Enlaces a otros sitios Web",
			icon: faCircleInfo,
			content: (
				<>
					<p className="mb-4">
						El Titular puede proporcionarle acceso a sitios Web de terceros mediante enlaces con la finalidad
						exclusiva de informar sobre la existencia de otras fuentes de información en Internet en las que
						podrá ampliar los datos ofrecidos en el Sitio Web.
					</p>
					<p className="mb-4">
						Estos enlaces a otros sitios Web no suponen en ningún caso una sugerencia o recomendación para que
						usted visite las páginas web de destino, que están fuera del control del Titular, por lo que el
						Titular no es responsable del contenido de los sitios web vinculados ni del resultado que obtenga
						al seguir los enlaces. Asimismo, el Titular no responde de los links o enlaces ubicados en los
						sitios web vinculados a los que le proporciona acceso.
					</p>
					<p className="mb-4">
						El establecimiento del enlace no implica en ningún caso la existencia de relaciones entre el
						Titular y el propietario del sitio en el que se establezca el enlace, ni la aceptación o
						aprobación por parte del Titular de sus contenidos o servicios.
					</p>
					<p>
						Si accede a un sitio web externo desde un enlace que encuentre en el Sitio Web usted deberá leer
						la propia política de privacidad del otro sitio web que puede ser diferente de la de este sitio
						Web.
					</p>
				</>
			),
		},
		{
			id: "propiedad",
			title: "Propiedad intelectual e industrial",
			icon: faBalanceScale,
			content: (
				<>
					<p className="mb-4">Todos los derechos están reservados.</p>
					<p>
						Todo acceso a este Sitio Web está sujeto a las siguientes condiciones: la reproducción, almacenaje
						permanente y la difusión de los contenidos o cualquier otro uso que tenga finalidad pública o
						comercial queda expresamente prohibida sin el consentimiento previo expreso y por escrito del
						Titular.
					</p>
				</>
			),
		},
		{
			id: "limitacion",
			title: "Limitación de responsabilidad",
			icon: faBalanceScale,
			content: (
				<>
					<p className="mb-4">
						La información y servicios incluidos o disponibles a través del Sitio Web pueden incluir
						incorrecciones o errores tipográficos. De forma periódica el Titular incorpora mejoras y/o cambios
						a la información contenida y/o los Servicios que puede introducir en cualquier momento.
					</p>
					<p className="mb-4">
						El Titular no declara ni garantiza que los servicios o contenidos sean interrumpidos o que estén
						libres de errores, que los defectos sean corregidos, o que el servicio o el servidor que lo pone a
						disposición estén libres de virus u otros componentes nocivos sin perjuicio de que el Titular
						realiza todos los esfuerzos en evitar este tipo de incidentes.
					</p>
					<p className="mb-4">
						El Titular declina cualquier responsabilidad en caso de que existan interrupciones o un mal
						funcionamiento de los Servicios o contenidos ofrecidos en Internet, cualquiera que sea su causa.
						Asimismo, el Titular no se hace responsable por caídas de la red, pérdidas de negocio a
						consecuencia de dichas caídas, suspensiones temporales de fluido eléctrico o cualquier otro tipo
						de daño indirecto que te pueda ser causado por causas ajenas a el Titular.
					</p>
					<p>
						Antes de tomar decisiones y/o acciones con base a la información incluida en el Sitio Web, el
						Titular le recomienda comprobar y contrastar la información recibida con otras fuentes.
					</p>
				</>
			),
		},
		{
			id: "exclusion",
			title: "Derecho de exclusión",
			icon: faGavel,
			content: (
				<p>
					El Titular se reserva el derecho a denegar o retirar el acceso al Sitio Web y los servicios
					ofrecidos sin necesidad de preaviso, a instancia propia o de un tercero, a aquellos usuarios que
					incumplan cualquiera de las condiciones de este Aviso Legal.
				</p>
			),
		},
		{
			id: "jurisdiccion",
			title: "Jurisdicción",
			icon: faGavel,
			content: <p>Este Aviso Legal se rige íntegramente por la legislación española.</p>,
		},
		{
			id: "contacto",
			title: "Contacto",
			icon: faCircleInfo,
			content: (
				<p>
					En caso de que usted tenga cualquier duda acerca de este Aviso Legal o quiera realizar cualquier
					comentario sobre el Sitio Web, puede enviar un mensaje de correo electrónico a la dirección:{" "}
					<a href="mailto:legal@losamosdelcalabozo.com" className="text-red-400 hover:text-red-300">
						legal@losamosdelcalabozo.com
					</a>
					.
				</p>
			),
		},
	];

	const scrollToSection = (id: string) => {
		const element = document.getElementById(id);
		if (element) {
			element.scrollIntoView({ behavior: "smooth", block: "start" });
			setActiveSection(id);
		}
	};

	return (
		<main className="bg-black text-white">
			{/* Hero Section */}
			<section
				className="relative py-32 bg-cover bg-center"
				style={{ backgroundImage: "url('/images/collections/Precios/custom.webp')" }}
			>
				<div className="absolute inset-0 bg-black/60"></div>
				<div className="container mx-auto px-4 max-w-4xl relative z-10">
					<motion.h1
						className="font-amarante text-5xl md:text-7xl mb-6 text-center text-white"
						initial={{ opacity: 0, y: -20 }}
						animate={{ opacity: 1, y: 0 }}
						transition={{ duration: 0.8 }}
					>
						<span className="headerFont inline-block pb-2 border-b-2 border-red-700">Aviso Legal</span>
					</motion.h1>

					<motion.p
						className="text-xl text-gray-300 max-w-3xl mx-auto text-center mb-12"
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						transition={{ delay: 0.3, duration: 0.6 }}
					>
						<strong className="">Información legal sobre Los Amos del Calabozo</strong>
					</motion.p>
				</div>
			</section>

			{/* Quick Navigation */}
			<section className="py-8 bg-gray-900">
				<div className="container mx-auto px-4 max-w-4xl">
					<div className="flex flex-wrap justify-center gap-4">
						{legalSections.map((section) => (
							<button
								key={section.id}
								onClick={() => scrollToSection(section.id)}
								className={`px-4 py-2 rounded-md transition-all ${
									activeSection === section.id
										? "bg-red-700 text-white"
										: "bg-gray-800 text-gray-300 hover:bg-gray-700"
								}`}
							>
								<FontAwesomeIcon icon={section.icon} className="mr-2" />
								{section.title}
							</button>
						))}
					</div>
				</div>
			</section>

			{/* Main Content Section */}
			<section className="py-16 bg-black">
				<div className="container mx-auto px-4 max-w-4xl">
					{legalSections.map((section) => (
						<motion.div
							key={section.id}
							id={section.id}
							initial={{ opacity: 0 }}
							whileInView={{ opacity: 1 }}
							viewport={{ once: true }}
							transition={{ duration: 0.6 }}
							className="mb-16"
						>
							<h2 className="text-3xl font-amarante headerFont mb-8 border-b-2 border-red-700 pb-2 inline-block">
								<FontAwesomeIcon icon={section.icon} className="mr-3 text-red-500" />
								{section.title}
							</h2>

							<div
								className={`bg-gray-900 rounded-lg p-6 border-l-4 transition-all duration-300 ${
									activeSection === section.id
										? "border-red-500 shadow-lg shadow-red-900/20"
										: "border-red-700"
								}`}
							>
								<div className="text-gray-300">{section.content}</div>
							</div>
						</motion.div>
					))}
				</div>
			</section>
		</main>
	);
};

export default LegalPage;
